import LoadableState from 'components/shared/loadable';
import PageTitle from 'components/shared/PageTitle';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { ArrowLeft } from 'react-feather';
import { requestJourneyContents } from 'actions/journeyViewer';
import { routes } from 'constants/config';
import DateFormat from 'constants/date_format';
import Loader from './Loader';
import Header from './Header';
import ContentsList from './ContentsList';

const JourneyViewer = props => {
  const {
    title,
    loading,
    dueBy,
    completed,
    completedAt,
    updatedAt,
    lastPublishedAt,
  } = props;
  const [isOverdue, setIsOverdue] = useState(false);

  const toLocalDate = date => {
    return moment(moment(date).format(DateFormat.fixed.ISO8601_LOCAL) + 'Z');
  };

  const formattedLocalDate = date => {
    return toLocalDate(date).format(DateFormat.MONTH_DAY_YEAR_SHORT);
  };

  useEffect(() => {
    props.requestJourneyContents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const checkOverdueStatus = () => {
      if (completed) setIsOverdue(false);
      else setIsOverdue(toLocalDate(dueBy) < new Date());
    };

    if (dueBy && !isOverdue) {
      const interval = setInterval(checkOverdueStatus(), 3600);

      return () => clearInterval(interval);
    }
  }, [completed, dueBy, isOverdue]);

  return (
    <div className="JourneyViewer">
      {title && <PageTitle title={title} />}
      {loading && <Loader />}
      <LoadableState loading={loading} opacity={0.5} speed={500}>
        {!props.loading && (
          <>
            <div className="JourneyViewer-topbar">
              <a className="JourneyViewer-actions" href={routes.LEARN}>
                <ArrowLeft className="JourneyViewer-actionIcon" size={16} />
                {t('journeys.viewer.back_to_learning_page')}
              </a>
              <div className="JourneyViewer-statuses">
                {updatedAt && (
                  <div className="JourneyViewer-duedate">
                    {t('templates.gallery.last_updated_on', {
                      date: formattedLocalDate(lastPublishedAt),
                    })}
                  </div>
                )}
                {((updatedAt && completed) || (updatedAt && dueBy)) && (
                  <div className="JourneyViewer-duedate">
                    &nbsp;&nbsp;•&nbsp;&nbsp;
                  </div>
                )}
                {completed && (
                  <div className="JourneyViewer-duedate">
                    {`${t('journeys.viewer.completed')} ${formattedLocalDate(
                      completedAt,
                    )}`}
                  </div>
                )}
                {dueBy && !completed && (
                  <div className="JourneyViewer-dueLabel">
                    <span className="JourneyViewer-duedate">
                      {`${t('journeys.viewer.due')} ${formattedLocalDate(
                        dueBy,
                      )}`}
                    </span>
                    {isOverdue && (
                      <div className="JourneyViewer-overdueChip">
                        <span className="JourneyViewer-overdueText">
                          {t('journeys.viewer.overdue')}
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <Header />
            <ContentsList />
          </>
        )}
      </LoadableState>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    title: state.title,
    description: state.description,
    loading: state.loading,
    dueBy: state.dueBy,
    startedAt: state.startedAt,
    completed: state.completed,
    updatedAt: state.updatedAt,
    lastPublishedAt: state.lastPublishedAt,
  };
};

const mapDispatchToProps = {
  requestJourneyContents,
};

export default connect(mapStateToProps, mapDispatchToProps)(JourneyViewer);
